// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'arrow-left';

export const Component = () => (
  <path d='m6.244 13.46 4.958 4.894c.232.137.37.365.37.686 0 .64-.323.96-.972.96a.922.922 0 0 1-.649-.275l-6.673-6.539-.093-.137C3.046 12.821 3 12.637 3 12.5c0-.046.046-.228.185-.549l.093-.137 6.673-6.54A.922.922 0 0 1 10.6 5c.649 0 .973.32.973.915 0 .365-.14.594-.37.731l-4.96 4.894h14.83c.602 0 .926.32.926.96 0 .64-.324.96-.927.96H6.244v.002Z' />
);

export const viewBox = '0 0 25 25';
